import * as t from 'io-ts';
import { fetchWrapper } from '../fetchWrapper';

export function getInventoryEmailEnabled() {
  return fetchWrapper({
    url: `/api/inventory-email-status`,
    dataType: t.boolean,
  });
}
